import { ROOM_NAMES_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IRoomName } from "../../shared/interfaces/room/IRoomName";

export const RoomNameService = {
  getAll: (params: IPagination) => requests.get(ROOM_NAMES_URL, params),
  create: (params: IRoomName) => requests.post(`${ROOM_NAMES_URL}`, params),
  getSingle: (id: number) => requests.get(`${ROOM_NAMES_URL}/${id}`),
  update: (params: IRoomName, id: number) =>
    requests.put(`${ROOM_NAMES_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${ROOM_NAMES_URL}/${id}`),
  sort: (ids: (number | string)[]) => requests.patch(`${ROOM_NAMES_URL}/sort`, { ids }),
};
